import * as React from 'react';
import Icon from 'components/Icon';
import { classNames } from 'utils/ui/css';

interface DownloadMenuButtonProps {
  onClick: () => void;
  label: React.ReactNode;
  testId: string;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'single' | 'all';
}

export function DownloadMenuButton({
  onClick,
  label,
  testId,
  disabled,
  loading,
  variant = 'single',
}: DownloadMenuButtonProps) {
  const iconClass = variant === 'all' ? 'ex3d-icon--download-all' : 'ex3d-icon--download';
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames('flex w-full items-center p-2 hover:text-neon-100', loading && 'cursor-wait')}
      data-testid={testId}
      disabled={disabled || loading}
      aria-busy={loading ? true : undefined}
    >
      <span className="grow text-left">{label}</span>
      {loading ? (
        <span aria-hidden="true" className="ml-4 size-5 animate-spin rounded-full border-b-2 border-white" />
      ) : (
        <Icon aria-hidden="true" className={`${iconClass} ml-4 size-5`} />
      )}
    </button>
  );
}
